module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product5-e8e358ca06d1f6a4497fd1905b171343.jpg";